import { quickOrderPageContainerStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderPageContainer";
import { css } from "styled-components";

quickOrderPageContainerStyles.leftColumnGridItem = {
    width: [12, 12, 6, 4, 4],
    css: css`
        padding-right: 0;
    `,
};

quickOrderPageContainerStyles.rightColumnGridItem = {
    width: [0, 0, 6, 8, 8],
    css: css`
        padding-left: 0;
    `,
};
